import { render, staticRenderFns } from "./mapping-tables.vue?vue&type=template&id=6f8b1341&"
import script from "./mapping-tables.vue?vue&type=script&lang=js&"
export * from "./mapping-tables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports